import React from 'react';
import { CommandItem } from '@/components/ui/command';
import { Check, History } from 'lucide-react';
import { StoredLocation } from '@/utils/locationUtils';

interface RecentLocationItemProps {
  location: StoredLocation;
  isSelected: boolean;
  onSelect: () => void;
  formatDate: (timestamp: number) => string;
}

export const RecentLocationItem: React.FC<RecentLocationItemProps> = ({
  location,
  isSelected,
  onSelect,
  formatDate
}) => {
  return (
    <CommandItem
      key={`recent-${location.timestamp}`}
      onSelect={onSelect}
      className="cursor-pointer"
    >
      <div className="flex flex-col w-full overflow-hidden">
        <div className="flex items-center">
          <History className="h-4 w-4 mr-2 text-muted-foreground" />
          <span>{location.description}</span>
          {isSelected && (
            <Check className="h-4 w-4 ml-auto" />
          )}
        </div>
        <span className="text-xs text-muted-foreground ml-6">
          {formatDate(location.timestamp)}
        </span>
      </div>
    </CommandItem>
  );
};